import { cx } from '@twind/core';
import { Subheading } from 'app/components/Typography';

import { MessageReadMarker } from './MessageReadMarker';

type Props = {
  name: string;
  src?: string;
  className?: string;
  messageIndex?: number;
};

const JoiningMessage = ({ name, src, className, messageIndex }: Props) => {
  const joinMessage = `${name} has joined the chat`;

  return (
    <div
      data-message-index={messageIndex}
      className={cx('flex gap-3 items-center', className)}
      role="status"
      aria-labelledby="joining-message"
      tabIndex={0}
    >
      {src ? (
        <img
          src={src}
          alt={`${name} avatar`}
          className="w-[24px] h-[24px] object-cover rounded-full"
        />
      ) : null}
      <Subheading
        id="joining-message"
        className="text-[#575757] font-semibold"
      >
        {joinMessage}
      </Subheading>
      {messageIndex ? <MessageReadMarker index={messageIndex} /> : null}
    </div>
  );
};

export default JoiningMessage;
